export default __webpack_public_path__ + "e6e5617997ec047c3ec55ef4249a8c19.png";